<app-header></app-header>
<main>
<div class="container below_header">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">         
      <div class="payment_detail_main" >
        <i class="fa fa-credit-card payment_detail_icon"></i>
        <span class="payment_detailtxt">Advance Payment Details</span>
        <div class="ui-g radio-group" style="width:250px;margin-bottom:10px">
            <div class="ui-g-12">
              <table>
                <tr>
                  <td>
                    <input type="radio" name="group1" value="FullPayment1" class="checkbox_modified" (change)="onRadioACHChecked($event)" checked>Pay via ACH
                  </td>
                  <td>
                    <input type="radio" name="group1" value="FullPayment2" class="checkbox_modified" (change)="onRadioCCChecked($event)">Pay via Amex
                  </td>
                </tr>
              </table>
            </div>
             
          </div>
       
      </div>
    </div>
  </div>  
<div class="row">
    <div class="col-lg-5 col-md-5 col-xs-12 ach_main" [hidden]="!ShowACH">
      <div class="ach_main_left">
        <!--   - added to dispay in advance payment page -->
        <p>Total Gross Cash Discount Price if paying by ACH</p>
        <p>Agency Commission</p>
        <p>Tax Amount (Tax applied only to Phoenix and New Mexico stations)</p>
        <p>Total Net Cash Discount Price if paying by ACH</p>
      </div>
      <div class="ach_main_right" *ngIf="!isLoading">
<!--   - added to dispay in advance payment page -->
        <p>{{advanceGrossAmount | currency:"CAD":"symbol-narrow"}}</p>
        <p>{{advanceCommAmount | currency:"CAD":"symbol-narrow"}}</p>
        <p>{{advanceTaxAmount | currency:"CAD":"symbol-narrow"}}</p>

        <p>{{advanceAmount | currency:"CAD":"symbol-narrow"}}</p>
      </div>
      <div class="ach_details_loading" *ngIf="isLoading">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}"></p-progressSpinner>
      </div>
      <div class="achbtn_main"><button [disabled]="isLoading" type="button" class="btn achbtn_modifi" (click)="Paynowprofile(1)">Click to Process</button></div>
    </div>
    <div class="col-lg-5 col-md-5 col-xs-12 cc_main" [hidden]="!ShowCC">
      <div class="cc_main_left">
         <!--   - added to dispay in advance payment page -->
         <p>Total Gross Regular Price if paying by credit card</p>
         <p>Agency Commission</p>
         <p>Tax Amount (Tax applied only to Phoenix and New Mexico stations )</p>
        <p>Total Net Regular Price if paying by credit card</p>
      </div>
      <div class="cc_main_right" *ngIf="!isLoading">
        <!--   - added to dispay in advance payment page -->
        <p>{{advanceGrossAmountCC | currency:"CAD":"symbol-narrow"}}</p>
        <p>{{advanceCommAmountCC | currency:"CAD":"symbol-narrow"}}</p>
        <p>{{advanceTaxAmountCC | currency:"CAD":"symbol-narrow"}}</p>
        <p>{{advanceAmountCC | currency:"CAD":"symbol-narrow"}}</p>
      </div>
      <div class="cc_details_loading" *ngIf="isLoading">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}"></p-progressSpinner>
      </div>
      <div class="achbtn_main"><button [disabled]="isLoading" type="button" class="btn achbtn_modifi" (click)="Paynowprofile(2)">Click to Process</button></div>                                
    </div>  
        <div class="col-lg-12 col-md-12 col-xs-12">                  
        <button type="button" (click)="goback()" class="btn goback"><i class="fa fa-angle-left"></i> Back</button>   
    </div>    
</div>
  </div>

</main>
